import React, { useEffect, useState } from "react";
import IUserModel, { IUserRollType } from "../../services/models/user";
import { View, Text } from "../Themed";

import UserService from "../../services/user";
import { DocumentData, QuerySnapshot } from "firebase/firestore";
import { ActivityIndicator, StyleSheet } from "react-native";
import UserItemComponent from "./UserItemComponent";
import { colors } from "../Shared";

import { RootState } from "../../services/store/app";
import { useSelector } from "react-redux";

const userService = new UserService();

export default function UserViewComponent() {
  const [init, setInit] = useState(false);
  const [users, setUsers] = useState<IUserModel[]>([]);
  const common = useSelector((state: RootState) => state.commonReducer);
  const isAdmin = common.user.roll > 0;

  useEffect(() => {
    userService.getUsersRealTime((snap: QuerySnapshot<DocumentData>) => {
      const docs = snap.docs.map((doc) => doc.data()) as IUserModel[];
      setUsers(docs);
      if (!init) {
        setInit(true);
      }
    });
  }, []);

  const updateStatus = async (user: IUserModel) => {
    if(!user){
      return user;
    }

    let status = false;
    if(!user.status){
      status = true;
    }

    await userService.changeStatus(user.uid, status, isAdmin);
  }

  const updateRoll = async (user: IUserModel) => {
    if(!user){
      return;
    }

    let roll: IUserRollType = 0;
    if(user.roll === 0){
      roll = 1; 
    }

    await userService.changeRoll(user.uid, roll, isAdmin);
  }
  return (
    <View
      style={[styles.container, { flexDirection: init ? "row" : "column" }]}
    >
      {!init ? (
        <View style={styles.loadingContainer}>
          <ActivityIndicator color={colors.bg.primary} size="large" />
        </View>
      ) : !users.length ? (
        <View>
          <Text>No hay usuarios disponibles</Text>
        </View>
      ) : (
        users.map((user, index) => (
          <UserItemComponent
            key={index}
            user={user}
            onActive={() => updateStatus(user)}
            onAdmin={() => updateRoll(user)}
            // onDelete={() => {}}
          />
        ))
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 5,
    flexWrap: "wrap",
    display: "flex",
    justifyContent: "space-evenly",
    alignContent: "flex-start",
  },
  loadingContainer: {
    flex: 1,
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
});
